import { Endpoints } from 'utils/endpoints';
import type { AxiosClient } from '../../api/client.ts';
import { trackError } from '@proposify/frontend-observability';
import type { ProspectResponseDto } from '@proposify/document-service-api-client';
import { isCrmCompositeId } from 'services/company-and-contacts/mappers';

export function generateProspectUid(prospect: ProspectResponseDto) {
  if (isCrmCompositeId(prospect.id)) {
    return prospect.id;
  }
  return `${prospect.id}-${prospect.type}`;
}

export type ProspectResponseType = { uid: string } & ProspectResponseDto;
export const apiProspectsRepository = {
  getProspects: async (
    queryParam: { offset?: number; limit?: number; search?: string } = {},
    apiDataClient: AxiosClient
  ): Promise<ProspectResponseType[]> => {
    try {
      const prospectsResponse = await apiDataClient.get<ProspectResponseDto[]>(Endpoints.getProspects, { params: queryParam });
      return prospectsResponse.map((prospect) => ({ ...prospect, uid: generateProspectUid(prospect) }));
    } catch (error) {
      trackError(error, { endpoint: 'getProspects' });
      throw error;
    }
  },
};
